import React, {useContext, useEffect} from 'react';
import { Outlet, useLoaderData, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { logoUrl } from '../utils/logoUrl';
import type { MunicipalityExtended } from '../api';
import {FooterContext} from "../layouts/AppLayout";
import { useLocalizationLabels } from '../context/LocalizationLabelContext';

export default function MunicipalityHelmet() {
    const municipality = useLoaderData() as MunicipalityExtended;
    const { bodyType } = useParams<{ bodyType?: string }>();
    const footerCntx = useContext(FooterContext);

    const {organNameOptionLabels} = useLocalizationLabels();

    const currentBodyType = (bodyType || Object.keys(municipality.organy)[0]) as keyof typeof municipality.organy;

    const setLatestMeetingAt = footerCntx?.setLatestMeetingAt;
    const setLatestMeetingNumber = footerCntx?.setLatestMeetingNumber;

    useEffect(() => {
        return () => {
            setLatestMeetingAt?.("");
            setLatestMeetingNumber?.("");
        };
    }, [setLatestMeetingAt, setLatestMeetingNumber]);

    if (currentBodyType && municipality?.organy[currentBodyType]) {
        const votingMessage = `hlasování ${currentBodyType}`;
        
        const organ = municipality.organy[currentBodyType];
        const organID = organ.id;

        const organNamelabel = organNameOptionLabels[organID]?.label ?? currentBodyType;
        const organAppName = organNameOptionLabels[organID]?.label_aplikace ?? currentBodyType;
        const organAppDescription = organNameOptionLabels[organID]?.label_popis_aplikace ?? `${organAppName} - otevřená data a vizualizace hlasování`;

        return (
            <>
                <Helmet>
                    <title>{organAppName}</title>
                    <meta name='description' content={organAppDescription} />
                    <meta
                        name='keywords'
                        content={`${organNamelabel}, ${municipality?.text_id}, ${currentBodyType}, ${votingMessage}, otevřená data, vizualizace`}
                    />
                    {municipality.logo && <meta property='og:image' content={logoUrl(municipality.text_id)} />}
                    <meta property='og:title' content={organAppName} />
                    <meta property='og:description' content={organAppDescription} />
                </Helmet>
                <Outlet />
            </>
        );
    }

    console.error("No body to go to");
    return null;
}
